export enum SocketEventPrefixType {
  Activity = 'activity',
  Activities = 'activities',
}
